import { Alert } from 'antd';
import React from 'react';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ICompanyWidget } from './ICompanyWidget';

export interface ICompanyWidgetConfigComponentProps
  extends IWidgetComponentProps<ICompanyWidget> {}

export function CompanyWidgetConfigComponent(
  props: ICompanyWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <div style={{ marginBottom: '12px' }}>
      <Alert
        type="info"
        message={
          <>
            Configurando un&apos;azienda in questo elemento impostando i campi
            con i relativi &quot;Attributo del titolare della richiesta&quot;,
            tutti i titolari della richiesta presenti all&apos;interno di questo
            elemento saranno collegati all&apos;azienda configurata come legali
            rappresentati.
          </>
        }
      />
      <div>
        <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
      </div>
    </div>
  );
}
